import { createStore } from "@stencil/store";
import { getAssets } from "../../../api/assetManagementApi/assets";
import { getSoftwares, getSoftwareTypes } from "../../../api/publicApi/createCase/software";
import { getNotificationTypes } from "../../../api/publicApi/createCase/notificationType";
import { getUserDetails } from "../../../api/publicApi/userDetails/getUserDetails";
import { mapUserDetailsToContactInfo } from "../../../api/publicApi/createCase/mapUserDetailsToContactInfo";
export const createApiStore = () => {
    const store = createStore({
        machinesLoading: true,
        machines: [],
        softwaresLoading: true,
        softwares: [],
        softwareTypes: [],
        notificationTypesLoading: true,
        notificationTypes: [],
        userDetailsLoading: true,
        contactInfo: null,
        isAllowedToCreateCase: null,
        loading: true
    });
    store.onChange("machinesLoading", () => updateLoading());
    store.onChange("softwaresLoading", () => updateLoading());
    store.onChange("notificationTypesLoading", () => updateLoading());
    store.onChange("userDetailsLoading", () => updateLoading());
    function updateLoading() {
        const { machinesLoading, softwaresLoading, notificationTypesLoading, userDetailsLoading } = store.state;
        store.state.loading = machinesLoading || softwaresLoading || notificationTypesLoading || userDetailsLoading;
    }
    return store;
};
export const loadFormDataFromPublicApi = async (apiStore, apiClient) => {
    apiStore.state.softwaresLoading = true;
    apiStore.state.notificationTypesLoading = true;
    getSoftwares(apiClient).then((softwares) => {
        apiStore.state.softwares = softwares;
        apiStore.state.softwareTypes = getSoftwareTypes(softwares);
        apiStore.state.softwaresLoading = false;
    });
    getNotificationTypes(apiClient).then((notificationTypes) => {
        apiStore.state.notificationTypes = notificationTypes;
        apiStore.state.notificationTypesLoading = false;
    });
    getUserDetails(apiClient).then((userDetails) => {
        var _a;
        apiStore.state.contactInfo = mapUserDetailsToContactInfo(userDetails);
        apiStore.state.isAllowedToCreateCase = ((_a = userDetails.userRoles) === null || _a === void 0 ? void 0 : _a.includes("service_full")) || false;
        apiStore.state.userDetailsLoading = false;
    });
};
export const loadFormDataFromAssetManagementApi = async (apiStore, apiClient) => {
    apiStore.state.machinesLoading = true;
    getAssets(apiClient).then((machines) => {
        apiStore.state.machines = machines;
        apiStore.state.machinesLoading = false;
    });
};
//# sourceMappingURL=apiStore.js.map
